import type { FunctionComponent } from 'react';
import React from 'react';
import styled from 'styled-components';
import type { ButtonProps } from '@material-ui/core/Button';
import Button from '@material-ui/core/Button';

const UnstyledTextButton: FunctionComponent<ButtonProps> = (props) => {
  return <Button disableRipple {...props} />;
};

export const TextButton = styled(UnstyledTextButton)`
  display: inline-block;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  vertical-align: inherit;
  background-color: inherit;
  min-width: inherit;
  color: ${({ theme }) => theme.palette.primary.main};
`;
